import { GrillaEl, PilaV } from '@/components/atomos';
import { Heading } from '@chakra-ui/react';
import { FC } from 'react';
import { PropsInstructivoNuevaOp } from '..';
import PasosInstructivo from './PasosInstructivo';

const SeccionPasosInstructivo: FC<PropsInstructivoNuevaOp> = (props) => {
  return (
    <GrillaEl colSpan={1} as={PilaV} w={'full'} alignItems={"start"}>
      <Heading size={'lg'} fontWeight={'medium'}>
        Como crear tu primera operación
      </Heading>
      <PasosInstructivo {...props}/>
    </GrillaEl>
  );
};

export default SeccionPasosInstructivo;
